import React, { Component } from 'react';
import $ from "jquery";
import { ApiClient } from "../libs/apiClient";
import { SERVICE_RESPONSE, tipoUnidad } from '../libs/utils/Const';
import ConfirmModalCartaPorte from './confirmModalCartaPorte';
import AreYouAgreeModal from './AreYouAgreeModal';
import SeriesModal from './SeriesModal';
import Select from 'react-select';
import StandardSelectModal from './StandardSelectModal';
import ItemsCreateModal from './ItemsCreateModal';
import { ItemsTransporte } from './NewOrder';

let apiClient = ApiClient.getInstance();

class TransporteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            subTipoRem: [],
            configVehicular: [],
            title: '',
            showAreYouAgreeModal: false,
            sucursales: [],
            transportType: [{ value: 'ENVSA', label: 'ENVASADO' }, { value: 'GRANE', label: 'GRANEL' }],
            items: [],
            pageTotal: 0,
            showAreYouAgreeModalDelete: false,
            itemDelete: '',
            idDelete: '',
            showPopup: false,
        };
    }
    componentDidMount = async () => {
        this._handelBack();
        this.searchTruckInfoCatalogs();
        await this.GetAllBranchOffices();
    }
    togglePopup = () => {
        const { showAlert } = this.props
        showAlert({ type: 'warning', message: `Esta acción genera una solicitud de traslado con los artículos configurados en la pestaña Capacidad de abastecimiento`, timeOut: 3000 });
    };
    GetAllBranchOffices = async () => {
        const data = {
            data: true
        }
        const listSucursales = await apiClient.getSucursales(data);
        const sucursales = listSucursales.data ? listSucursales.data.map(sucursal => ({
            value: sucursal.pk_Sucursal,
            label: `${sucursal.nombre}`
        })) : [];

        this.setState({
            sucursales
        })
    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    }

    //#region Get catalogs SAT
    searchTruckInfoCatalogs = async filter => {
        await this.callTruckInfoCatalogs(filter);
    };
    callTruckInfoCatalogs = async (filter = { action: '---' }) => {
        const { enableSpinner, tipoTransporte } = this.props;
        filter.transporte = tipoTransporte;
        enableSpinner(true);
        let infoTransporteResponse = await apiClient.getTransporteInfoCatalogs(filter);
        enableSpinner(false);
        if (infoTransporteResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                subTipoRem: infoTransporteResponse.data.subTipoRem,
                configVehicular: infoTransporteResponse.data.configVehicular
            });
        }
    };
    //#endregion

    restartTabs = () => {
        const { tipoTransporte } = this.props;
        switch (tipoTransporte) {
            case 'Aereo':
                $('#nav-transporte-tab-1-1').removeClass('active');
                $('#nav-transporte-tab-2-1').removeClass('active');
                $('#nav-transporte-tab-3-1').removeClass('active');

                $('#nav-transporte-tab-1-1').removeClass('nav-link-current');
                $('#nav-transporte-tab-2-1').removeClass('nav-link-current');
                $('#nav-transporte-tab-3-1').removeClass('nav-link-current');

                $('#Section-1-1').removeClass('active');
                $('#Section-2-1').removeClass('active');
                $('#Section-3-1').removeClass('active');

                $('#Section-1-1').removeClass('show');
                $('#Section-2-1').removeClass('show');
                $('#Section-3-1').removeClass('show');

                $('#nav-transporte-tab-1-1').addClass('active');
                $('#Section-1-1').addClass('active');
                $('#Section-1-1').addClass('show');
                break;
            case 'Autotransporte':
                $('#nav-transporte-tab-1-2').removeClass('active');
                $('#nav-transporte-tab-2-2').removeClass('active');
                $('#nav-transporte-tab-3-2').removeClass('active');
                $('#nav-transporte-tab-consecutives').removeClass('active');
                $('#nav-transporte-tab-items').removeClass('active');

                $('#nav-transporte-tab-1-2').removeClass('nav-link-current');
                $('#nav-transporte-tab-2-2').removeClass('nav-link-current');
                $('#nav-transporte-tab-3-2').removeClass('nav-link-current');
                $('#nav-transporte-tab-consecutives').removeClass('nav-link-current');
                $('#nav-transporte-tab-items').removeClass('nav-link-current');

                $('#Section-1-2').removeClass('active');
                $('#Section-2-2').removeClass('active');
                $('#Section-3-2').removeClass('active');
                $('#seriesAndConsecutives').removeClass('active');
                $('#SectionItems').removeClass('active');

                $('#Section-1-2').removeClass('show');
                $('#Section-2-2').removeClass('show');
                $('#Section-3-2').removeClass('show');
                $('#seriesAndConsecutives').removeClass('show');
                $('#SectionItems').removeClass('show');

                $('#nav-transporte-tab-1-2').addClass('active');
                $('#Section-1-2').addClass('active');
                $('#Section-1-2').addClass('show');
                break;
            case 'Ferroviario':
                $('#nav-transporte-tab-1-3').removeClass('active');
                $('#nav-transporte-tab-2-3').removeClass('active');

                $('#nav-transporte-tab-1-3').removeClass('nav-link-current');
                $('#nav-transporte-tab-2-3').removeClass('nav-link-current');

                $('#Section-1-3').removeClass('active');
                $('#Section-2-3').removeClass('active');

                $('#Section-1-3').removeClass('show');
                $('#Section-2-3').removeClass('show');

                $('#nav-transporte-tab-1-3').addClass('active');
                $('#Section-1-3').addClass('active');
                $('#Section-1-3').addClass('show');
                break;
            case 'Maritimo':
                $('#nav-transporte-tab-1-4').removeClass('active');
                $('#nav-transporte-tab-2-4').removeClass('active');
                $('#nav-transporte-tab-3-4').removeClass('active');
                $('#nav-transporte-tab-4-4').removeClass('active');

                $('#nav-transporte-tab-1-4').removeClass('nav-link-current');
                $('#nav-transporte-tab-2-4').removeClass('nav-link-current');
                $('#nav-transporte-tab-3-4').removeClass('nav-link-current');
                $('#nav-transporte-tab-4-4').removeClass('nav-link-current');

                $('#Section-1-4').removeClass('active');
                $('#Section-2-4').removeClass('active');
                $('#Section-3-4').removeClass('active');
                $('#Section-4-4').removeClass('active');

                $('#Section-1-4').removeClass('show');
                $('#Section-2-4').removeClass('show');
                $('#Section-3-4').removeClass('show');
                $('#Section-4-4').removeClass('show');

                $('#nav-transporte-tab-1-4').addClass('active');
                $('#Section-1-4').addClass('active');
                $('#Section-1-4').addClass('show');
                break;
            default: break;
        }
    };

    changeTitleTransporte = () => {
        const { tipoTransporte } = this.props;
        switch (tipoTransporte) {
            case 'Aereo': return 'TRANSPORTE AÉREO';
            case 'Autotransporte': return 'AUTOTRANSPORTE';
            case 'Ferroviario': return 'TRANSPORTE FERROVIARIO';
            case 'Maritimo': return 'TRANSPORTE MARÍTIMO';
            default: return 'AUTOTRANSPORTE';
        }
    }

    closeModal = () => {
        $('#Transporte').modal('hide');
        this.restartTabs();
        this.changeTipoTransporte('Autotransporte');
        this.openCloseAgreeModal(false);
    }

    openCloseAgreeModal = async (status) => {
        await this.setState({ showAreYouAgreeModal: status });
        if (status) $('#areYouAgreeModal').modal('show');
        else $('#areYouAgreeModal').modal('hide');
    }

    //#region CRUD
    sendModel = () => {
        const { sendModel, model } = this.props;
        if (this.validateModel()) {
            sendModel(model);
        }
        this.restartTabs();
    };

    deleteModel = () => {
        // const {deleteModel, model} = this.props;
        // deleteModel(model.Codigo); 
        $('#confirmModalCartaPorte').modal('show');
        this.restartTabs();
    };
    acceptEditMode = () => {
        const { acceptEditMode, model, showAlert } = this.props;

        let flagCapital = false;
        for (let index = 0; index < model.Items.length; index++) {
            const item = model.Items[index];

            if (item.Capital === 0) {
                flagCapital = true;
                showAlert({ type: 'warning', message: `Es obligatorio asignar un valor de capital al artículo ${item.ItemCode}.` });
            }
        }
        if (flagCapital) return;
        this.openCloseAgreeModal(false);
        if (this.validateModel()) {
            acceptEditMode(model);
        }
    };
    cancelEditMode = () => {
        const { cancelEditMode } = this.props;
        this.openCloseAgreeModal(false);
        cancelEditMode();
        this.setState({
            editMode: false,
        });
    };
    editMode = () => {
        this.setState({
            editMode: !this.state.editMode,
        });
    };
    //#endregion

    //#region FieldModel
    // Actualiza el valor de los campos
    changeTypeSell = (event) => {
        const { model } = this.props;
        model.U_FMB_SellType = event?.value ?? null
        this.refreshModel(model);
    }
    changeTipoUnidad = (event) => {
        const { model } = this.props;
        model.TipodeUnidad = event?.value ?? null
        this.refreshModel(model);
    }
    changeSucursal = (event) => {
        const { model } = this.props;
        model.U_FMB_Sucursal = event?.value ?? null
        this.refreshModel(model);
    }
    changePolygon = (event) => {
        const { model } = this.props;
        model.Polygon = event?.value ?? null
        this.refreshModel(model);
    }
    changeChofer = (event) => {
        const { model } = this.props;
        model.U_FMB_Driver = event?.value ?? null
        this.refreshModel(model);
    }
    selectBinLocation = (value) => {

        const { model } = this.props
        $("#sucursalLocationsModal").modal("hide");
        this.setState({
            listBinLocations: [],
            showBinLocationsModal: false,
        })
        model.U_AbsEntry = value?.AbsEntry ?? null;
        model.U_FMB_BinLocation = value?.BinCode ?? null;
        this.refreshModel(model);

    }
    searchLocations = async () => {
        const { showAlert, model, enableSpinner } = this.props;
        if ((model?.U_FMB_Sucursal ?? '') == '') {
            showAlert({ type: 'warning', message: 'Selecciona una sucursal' });
            return;
        }
        $("#sucursalLocationsModal").modal("hide");
        this.setState({
            listBinLocations: [],
            showBinLocationsModal: false,
        })
        const search = {
            Sucursal: model?.U_FMB_Sucursal ?? null
        }
        enableSpinner(true);
        let responseApi = await apiClient.getBinLocationBySucursal(search);
        enableSpinner(false);
        if (responseApi.status == SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                listBinLocations: responseApi?.data ?? [],
                showBinLocationsModal: true,
            }, () => {
                $("#sucursalLocationsModal").modal("show");
            })
        } else {
            showAlert({ type: 'warning', message: responseApi?.message ?? 'No se encontraron resultados' });
        }
    }
    changeRoadMap = (val) => {
        const { model } = this.props;
        model.roadMap = val.target.checked ? 'Y' : 'N';
        this.refreshModel(model);
    }
    changeFieldModel = (model, key, event) => {
        const { showAlert } = this.props;

        if (key === 'PesoBrutoVehicular') {
            if (isNaN(event.nativeEvent.target.value)) {
                showAlert({ type: 'warning', message: 'El campo PesoBrutoVehicular solo permite números' });
                return;
            }
        }
        if (key === 'AnioModeloVM') {
            if (isNaN(event.nativeEvent.target.value)) {
                showAlert({ type: 'warning', message: 'El campo Año modelo VM solo permite números' });
                return;
            }
        }

        // if (key === 'CodigoUnidad') {
        //     if (isNaN(event.nativeEvent.target.value)) {
        //         showAlert({ type: 'warning', message: 'El código unidad solo permite números' });
        //         return;
        //     }
        // }

        if (key === 'PrimaSeguro') {
            if (isNaN(event.nativeEvent.target.value)) {
                showAlert({ type: 'warning', message: 'El campo PrimaSeguro solo permite números' });
                return;
            }
        }

        // if (key === 'PolizaRespCivil') {
        //     if (isNaN(event.nativeEvent.target.value)) {
        //         showAlert({ type: 'warning', message: 'El campo PolizaRespCivil solo permite números' });
        //         return;
        //     }
        // }

        // if (key === 'PolizaMedAmbiente') {
        //     if (isNaN(event.nativeEvent.target.value)) {
        //         showAlert({ type: 'warning', message: 'El campo PolizaMedAmbiente solo permite números' });
        //         return;
        //     }
        // }

        // if (key === 'PolizaCarga') {
        //     if (isNaN(event.nativeEvent.target.value)) {
        //         showAlert({ type: 'warning', message: 'El campo PolizaCarga solo permite números' });
        //         return;
        //     }
        // }
        model[key] = event.nativeEvent.target.value;
        this.refreshModel(model);
    };
    changeFieldArrayModel = (model, key, subKey, index, event) => {
        model[key][index][subKey] = event.nativeEvent.target.value;
        this.refreshModel(model);
    };

    // Agrega y elimina elemento al campo tipo array
    removeElement = (model, key, index) => {
        model[key].splice(index, 1);
        this.refreshModel(model);
    }
    addElement = (model, key, element) => {
        const { showAlert } = this.props;
        if (key === 'Remolques' && model[key].length === 50) {
            showAlert({ type: 'warning', message: 'Limite de remolques excedido' });
            return;
        } else {
            model[key].push(element)
        }
        this.refreshModel(model);
    }

    // change TipoTransporte
    changeTipoTransporte = tipoTransporte => {
        const { refreshTipoTransporte } = this.props;
        refreshTipoTransporte(tipoTransporte);
        this.restartTabs();
    };

    // Funcion para validar campos requeridos
    validateModel = () => {
        const { model, showAlert } = this.props;

        //#region ******************** HEADER ********************
        if (model.PlacaVM === undefined || model.PlacaVM === '') {
            showAlert({ type: 'warning', message: 'El campo PlacaVM no puede estar vacío' });
            return false;
        }
        if (model.AnioModeloVM === undefined || model.AnioModeloVM === '') {
            showAlert({ type: 'warning', message: 'El campo AnioModeloVM no puede estar vacío' });
            return false;
        }
        if (model.CodigoUnidad === undefined || model.CodigoUnidad === '' || model.CodigoUnidad === 'null' || model.CodigoUnidad === null) {
            showAlert({ type: 'warning', message: 'El campo CodigoUnidad no puede estar vacío' });
            return false;
        }
        if (model.TipodeUnidad === undefined || model.TipodeUnidad === '' || model.TipodeUnidad === 'null' || model.TipodeUnidad === null) {
            showAlert({ type: 'warning', message: 'El campo TipodeUnidad no puede estar vacío' });
            return false;
        }
        //#endregion ******************** HEADER ********************

        //#region ******************** GENERAL ********************
        if (model.PermSCT === undefined || model.PermSCT === '') {
            showAlert({ type: 'warning', message: 'El campo PermSCT no puede estar vacío' });
            return false;
        }
        if (model.NumPermisoSCT === undefined || model.NumPermisoSCT === '') {
            showAlert({ type: 'warning', message: 'El campo NumPermisoSCT no puede estar vacío' });
            return false;
        }
        // if (model.ConfigVehicular === undefined || model.ConfigVehicular === '') {
        //     showAlert({ type: 'warning', message: 'El campo ConfigVehicular no puede estar vacío' });
        //     return false;
        // }
        //#endregion ******************** GENERAL ********************

        //#region ******************** SEGUROS ********************
        if (model.AseguraRespCivil === undefined || model.AseguraRespCivil === '') {
            showAlert({ type: 'warning', message: 'El campo AseguraRespCivil no puede estar vacío' });
            return false;
        }
        if (model.PolizaRespCivil === undefined || model.PolizaRespCivil === '') {
            showAlert({ type: 'warning', message: 'El campo PolizaRespCivil no puede estar vacío' });
            return false;
        }
        if (!(model.AseguraMedAmbiente !== "" && model.PolizaMedAmbiente !== "" || model.AseguraMedAmbiente === "" && model.PolizaMedAmbiente === "")) {
            showAlert({ type: 'warning', message: 'El campo AseguraMedAmbiente / PolizaMedAmbiente no puede estar vacío' });
            return false;
        }
        if (!(model.AseguraCarga !== "" && model.PolizaCarga !== "" || model.AseguraCarga === "" && model.PolizaCarga === "")) {
            showAlert({ type: 'warning', message: 'El campo AseguraCarga / PolizaCarga no puede estar vacío' });
            return false;
        }
        if (model.PrimaSeguro == '0.00' || model.PrimaSeguro === 0) {
            showAlert({ type: 'warning', message: 'El campo PrimaSeguro tiene que ser diferente de cero' });
            return false;
        }
        //#endregion ******************** SEGUROS ********************

        //#region ******************** REMOLQUES ********************
        // if (model.ConfigVehicular !== 'VL' && model.ConfigVehicular !== 'OTROEVGP') {
        //     if (model.Remolques.length > 0) {
        //         for (let index = 0; index < model.Remolques.length; index++) {
        //             const element = model.Remolques[index];
        //             if (element.SubTipoRem === undefined || element.SubTipoRem === '') {
        //                 showAlert({ type: 'warning', message: 'El campo SubTipoRem no puede estar vacío' });
        //                 return false;
        //             }
        //             if (element.Placa === undefined || element.Placa === '') {
        //                 showAlert({ type: 'warning', message: 'El campo Placa no puede estar vacío' });
        //                 return false;
        //             }
        //         }
        //     }
        // }
        //#endregion ******************** REMOLQUES ********************
        //#region ******************** APPS LLAMAGAS  ********************
        if ((model?.U_FMB_Sucursal ?? '') === '') {
            showAlert({ type: 'warning', message: 'Selecciona una sucursal' });
            return false;
        }
        if ((model?.U_FMB_Driver ?? '') === '') {
            showAlert({ type: 'warning', message: 'Selecciona un chofer' });
            return false;
        }
        if ((model?.U_FMB_BinLocation ?? '') === '') {
            showAlert({ type: 'warning', message: 'Selecciona la ubicación de la unidad' });
            return false;
        }
        if ((model?.U_FMB_SellType ?? '') === '') {
            showAlert({ type: 'warning', message: 'Selecciona el tipo de venta' });
            return false;
        }
        //#endregion ******************** APPS LLAMAGAS ********************
        return true;
    };

    refreshModel = model => {
        const { refreshModel } = this.props;
        refreshModel(model);
    };

    //#endregion

    //#region Transportes render

    // Transporte Aereo render
    renderAirTransportHeader = () => {
        const { action, view, model } = this.props;
        const { editMode } = this.state;
        return (
            <div className="row">
                {/*PRIMER COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*Código*/}
                    {(action != 1 && !editMode) && <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardCode"
                            disabled={(action == 2 || action == 1) && !editMode ? true : false}
                            //    onChange={(event) => this.changeFieldModel(model, "CodigoTransporteAereo", event)}
                            value={model.CodigoTransporteAereo ? model.CodigoTransporteAereo : ""}
                        />
                    </div>}
                    {/*PermSCT*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">PermSCT</span>
                        </div>
                        <select id="txtGroupCode" className="form-control "
                            value={model.PermSCT ? model.PermSCT : ""}
                            onChange={(event) => this.changeFieldModel(model, "PermSCT", event)}
                            disabled={(action == 2 && !editMode) ? true : false}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                            <option value=''>Seleccione una opción</option>
                            <option value='TPTA01'>TPTA01.Concesión y/o autorización para el servicio regular nacional y/o internacional para empresas mexicanas</option>
                            <option value='TPTA02'>TPTA02.Permiso para el servicio aéreo regular de empresas extranjeras</option>
                            <option value='TPTA03'>TPTA03.Permiso para el servicio nacional e internacional no regular de fletamento</option>
                        </select>
                    </div>
                </div>

                {/*SEGUNDA COLUMNA*/}
                <div className="col-12 col-md-6">

                    {/*MatriculaAeronave*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">MatriculaAeronave</span>
                                <span className="d-inline d-xl-none">Matrícula</span>
                            </span>
                        </div>
                        <input type=" text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardName"
                            maxLength={10}
                            disabled={(action == 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "MatriculaAeronave", event)}
                            value={model.MatriculaAeronave ? model.MatriculaAeronave : ""}
                        />
                    </div>

                    {/*NumPermisoSCT*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">NumPermisoSCT</span>
                                <span className="d-inline d-xl-none">Núm Permiso</span>
                            </span>
                        </div>
                        <input type=" text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardName"
                            disabled={(action == 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "NumPermisoSCT", event)}
                            value={model.NumPermisoSCT ? model.NumPermisoSCT : ""}
                        />
                    </div>

                </div>
            </div>
        )
    }

    renderAirTransportBody = () => {
        const { model, action, countries } = this.props;
        const { editMode, subTipoRem, configVehicular } = this.state;
        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-transporte-tab-1-1"
                            data-toggle="tab"
                            href="#Section-1-1"
                            role="tab"
                            aria-controls="Section-1-1"
                            aria-selected="true">
                            Datos transporte
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-transporte-tab-2-1"
                            data-toggle="tab"
                            href="#Section-2-1"
                            role="tab"
                            aria-controls="Section-2-1"
                            aria-selected="false">
                            Poliza Seguro
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-transporte-tab-3-1"
                            data-toggle="tab"
                            href="#Section-3-1"
                            role="tab"
                            aria-controls="Section-3-1"
                            aria-selected="false">
                            Datos Embarcación
                        </a>
                    </div>
                </nav>
                <div className="tab-content" style={{ textAlign: 'left' }}>


                    {/* APARTADO Datos transporte */}
                    <div className="container tab-pane active"
                        id="Section-1-1"
                        role="tab"
                        aria-labelledby="nav-transporte-tab-1-1"
                    //  style={{maxHeight: 500}}
                    >

                        <div className="row g-3">
                            {/*Primera columna*/}
                            <div className="col-12 col-md-6">

                                {/*NumeroGuia */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">NumeroGuia</span>
                                            <span className="d-inline d-xl-none">Núm. Guía</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NumeroGuia", event)}
                                        value={model.NumeroGuia ? model.NumeroGuia : ""}
                                    />
                                </div>

                                {/*LugarContrato */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">LugarContrato</span>
                                            <span className="d-inline d-xl-none">Lugar</span>
                                        </span>
                                    </div>

                                    <select id="txtGroupCode" className="form-control" value={model.LugarContrato ? model.LugarContrato : ""}
                                        onChange={(event) => this.changeFieldModel(model, "LugarContrato", event)}
                                    >
                                        <option value=''>Seleccione una opción</option>
                                        {!!countries && countries.map((dato => {
                                            return (
                                                <option value={dato.c_Pais}>{dato.Nombre}</option>
                                            );
                                        }))}
                                    </select>

                                    {/* <input type="text" className="form-control"
                                            style={{backgroundColor: 'transparent',borderColor: '#ced4da',color: '#000'}}
                                            id="txtTel1"
                                            disabled={(action == 2 && !editMode) ? true : false}
                                            onChange={(event) => this.changeFieldModel(model, "LugarContrato", event)}
                                            value={model.LugarContrato ? model.LugarContrato : ""}
                                        /> */}
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6">
                                {/*CodigoTransportista*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">CodigoTransportista</span>
                                            <span className="d-inline d-xl-none">Transportista</span>
                                        </span>
                                    </div>
                                    <select id="txtGroupCode" className="form-control btn-outline-secondary"
                                        value={model.CodigoTransportista ? model.CodigoTransportista.trim() : ""}
                                        onChange={(event) => this.changeFieldModel(model, "CodigoTransportista", event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                        <option value=''>Seleccione una opción</option>
                                        <option value='CA008'>CA008. Air Canada</option>
                                        <option value='CA009'>CA009. Air Transat (Transat A. T.)</option>
                                        <option value='CA010'>CA010. Canjet (Imp Group Limited/Canjet Airlines)</option>
                                        <option value='CA039'>CA039. 21 Air</option>
                                        <option value='CA040'>CA040. Abx (Abx Air)</option>
                                        <option value='CA041'>CA041. Alaska Airlines</option>
                                        <option value='CA140'>CA140. Aéreo Calafia</option>
                                        <option value='CA141'>CA141. Aerolíneas Damojh (Global Air )</option>
                                        <option value='CA142'>CA142. Aeromar</option>

                                        {/* {!!TipoDerechoDePaso && TipoDerechoDePaso.map( (dato => {
                                            return(
                                                <option value={dato.Clave}>{dato.Clave}. {dato.Descripcion}</option>
                                            );
                                        }))} */}
                                    </select>
                                </div>

                            </div>

                        </div>
                    </div>

                    {/* APARTADO PolizaSeguro */}
                    <div className="container tab-pane fade"
                        id="Section-2-1"
                        role="tab"
                        aria-labelledby="nav-transporte-tab-2-1"
                    //  style={{maxHeight: 500}}
                    >

                        <div className="row g-3">
                            {/*Primera columna*/}
                            <div className="col-12 col-md-6">

                                {/*NombreAseg */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">NombreAseg</span>
                                            <span className="d-inline d-xl-none">Aseguradora</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NombreAseg", event)}
                                        value={model.NombreAseg ? model.NombreAseg : ""}
                                    />
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6">
                                {/*NumPolizaSeguro */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">NumPolizaSeguro</span>
                                            <span className="d-inline d-xl-none">Núm Poliza</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NumPolizaSeguro", event)}
                                        value={model.NumPolizaSeguro ? model.NumPolizaSeguro : ""}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* APARTADO DatosEmbarcacion */}
                    <div className="container tab-pane fade"
                        id="Section-3-1"
                        role="tab"
                        aria-labelledby="nav-transporte-tab-3-1"
                    //  style={{maxHeight: 500}}
                    >

                        <div className="row">
                            {/*Primera columna*/}
                            <div className="col-12 col-md-6">
                                {/*RFCEmbarcador */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">RUT Embarcador</span>
                                            <span className="d-inline d-xl-none">RUT</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "RFCEmbarcador", event)}
                                        value={model.RFCEmbarcador ? model.RFCEmbarcador : ""}
                                    />
                                </div>

                                {/*NumRegIdTribEmbarc */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">NumRegIdTribEmbarc</span>
                                            <span className="d-inline d-xl-none">Reg Tributario</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NumRegIdTribEmbarc", event)}
                                        value={model.NumRegIdTribEmbarc ? model.NumRegIdTribEmbarc : ""}
                                    />
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6">
                                {/*NombreEmbarcador */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">NombreEmbarcador</span>
                                            <span className="d-inline d-xl-none">Embarcador</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NombreEmbarcador", event)}
                                        value={model.NombreEmbarcador ? model.NombreEmbarcador : ""}
                                    />
                                </div>

                                {/*ResidenciaFiscalEmbarc */}
                                <div className="input-group mb-3" style={{ display: model.NumRegIdTribEmbarc !== '' ? '' : 'none' }}>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">ResidenciaFiscalEmbarc</span>
                                            <span className="d-inline d-xl-none">Res Fiscal</span>
                                        </span>
                                    </div>

                                    <select id="txtGroupCode" className="form-control" value={model.ResidenciaFiscalEmbarc ? model.ResidenciaFiscalEmbarc.trim() : ""}
                                        onChange={(event) => this.changeFieldModel(model, "ResidenciaFiscalEmbarc", event)}
                                    >
                                        <option value=''>Seleccione una opción</option>
                                        {!!countries && countries.map((dato => {
                                            return (
                                                <option value={dato.c_Pais}>{dato.Nombre}</option>
                                            );
                                        }))}
                                    </select>

                                    {/* <input type="text" className="form-control"
                                            style={{backgroundColor: 'transparent',borderColor: '#ced4da',color: '#000'}}
                                            id="txtTel1"
                                            disabled={(action == 2 && !editMode) ? true : false}
                                            // onChange={(event) => this.changeFieldModel(model, "ResidenciaFiscalEmbarc", event)}
                                            value={model.ResidenciaFiscalEmbarc ? model.ResidenciaFiscalEmbarc : ""}
                                        /> */}
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // configuración de remolques para Carta Porte 
    changeRemolqueStatus = (index, status) => {
        const { cartaPorteModel, refreshCartaPorteModel, showAlert } = this.props;
        // Declarar objeto auxiliar, no funciono {...cartaPorteModel} ni Object.assign({}, cartaPorteModel);
        let cartaPorteModelAux = JSON.parse(JSON.stringify(cartaPorteModel));
        cartaPorteModelAux.ConfRemolques[index].Active = status;

        let activos = cartaPorteModelAux.ConfRemolques.filter(elemento => elemento.Active === true);
        if (activos.length > 2) { return showAlert({ type: 'warning', message: 'Solo se puede seleccionar 2 remolques', timeOut: 10000 }); }

        refreshCartaPorteModel(cartaPorteModelAux);
    }

    // Autotransporte render
    renderAutoTransporteHeader = () => {
        const { model, action, view, Drivers, ActualRoutes } = this.props;
        const { editMode, sucursales, transportType } = this.state;
        const filteredActualRoutes = ActualRoutes.map(route => ({ value: route.codigo, label: route.codigo }))
        return (
            <div className="row">
                {/*PRIMER COLUMNA SOCIOS DE NEGOCIO*/}
                <div className="col-12 col-md-6">
                    {/*Código DE TRUCK MANAGER*/}
                    {/*(action != 1 && !editMode) && */<div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <input type="text" className="form-control"
                            // style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardCode"
                            // disabled={(action == 2 || action == 1) && !editMode ? true : false}
                            disabled={true}
                            value={model.CodigoAutotransporte ? model.CodigoAutotransporte : ""}
                        />
                    </div>}
                    {/*PlacaVM TRUCK MANAGER*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Placa</span>
                        </div>
                        <input type=" text" className="form-control input-sm"
                            id="txtGroupCode"
                            disabled={(action == 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "PlacaVM", event)}
                            value={model.PlacaVM ? model.PlacaVM : ""}
                        />
                    </div>

                    {/*SUCURSAL*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Sucursal</span>
                        </div>
                        <Select
                            options={sucursales}
                            value={sucursales.find(opt => opt.value === model?.U_FMB_Sucursal) || null}
                            onChange={this.changeSucursal}
                            placeholder="Escribe para buscar sucursal"
                            isDisabled={action === 2 && !editMode}
                            isSearchable={true}
                            isClearable={true}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1 }),
                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        />
                        {/* <select
                            name="select"
                            className="form-control"
                            id="selectDocTypeDocumentSearch"
                            disabled={(action === 2 && !editMode) ? true : false}
                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                            value={model.U_FMB_Sucursal ? model.U_FMB_Sucursal : ""}
                            onChange={(event) => this.changeFieldModel(model, "U_FMB_Sucursal", event)}
                        >
                            <option value="">Selecciona sucursal</option>
                            {sucursales && sucursales.map((sucur, index) => {
                                return (
                                    <option key={'optionSuc' + index} value={sucur.pk_Sucursal}>{sucur.nombre}</option>
                                )
                            })}
                        </select> */}
                    </div>

                    {/*Chofer*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Operador</span>
                        </div>
                        <Select
                            options={Drivers ?? []}
                            value={Drivers?.find(opt => opt.value === model?.U_FMB_Driver) || null}
                            onChange={this.changeChofer}
                            placeholder="Escribe para buscar chofer"
                            isDisabled={action === 2 && !editMode}
                            isSearchable={true}
                            isClearable={true}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1 }),
                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        />
                    </div>

                    {/* UBICACION UNIDAD */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Ubicación</span>
                        </div>
                        <input type=" text" className="form-control"
                            disabled={(action === 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "U_FMB_BinLocation", event)}
                            value={model.U_FMB_BinLocation ? model.U_FMB_BinLocation : ""}
                        />
                        <button type="button"
                            disabled={(action === 2 && !editMode) ? true : false}
                            className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                            onClick={this.searchLocations}>
                            <i className="fa fa-search" />
                        </button>
                    </div>

                    {/*POLÍGONO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Polígono</span>
                                <span className="d-inline d-xl-none">Polígono</span>
                            </span>
                        </div>
                        <Select
                            options={filteredActualRoutes}
                            value={filteredActualRoutes.find(opt => opt.value === model?.Polygon) || null}
                            onChange={this.changePolygon}
                            placeholder="Escribe para buscar un polígono"
                            isDisabled={action === 2 && !editMode}
                            isSearchable={true}
                            isClearable={true}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1 }),
                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        />
                    </div>

                </div>

                {/*SEGUNDA COLUMNA SOCIOS DE NEGOCIO*/}
                <div className="col-12 col-md-6">

                    {/*AnioModeloVM TRUCK*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Año del Modelo</span>
                                <span className="d-inline d-xl-none">Año Modelo</span>
                            </span>
                        </div>
                        <input type=" text" className="form-control input-sm"
                            id="txtGroupCode"
                            maxLength={5}
                            disabled={(action == 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "AnioModeloVM", event)}
                            value={model.AnioModeloVM ? model.AnioModeloVM : ""}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Codigo de Unidad</span>
                                <span className="d-inline d-xl-none">Cód Unidad</span>
                            </span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardCode"
                            maxLength={20}
                            disabled={(action == 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "CodigoUnidad", event)}
                            value={model.CodigoUnidad ? model.CodigoUnidad : ""}
                        />
                    </div>
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de Unidad</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardCode"
                            maxLength={200}
                            disabled={(action == 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "TipodeUnidad", event)}
                            value={model.TipodeUnidad ? model.TipodeUnidad : ""}
                        />
                    </div> */}
                    {/* CARGA SOPORTADA */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Carga Maxima (T)</span>
                                <span className="d-inline d-xl-none">Carga Máx</span>
                            </span>
                        </div>
                        <input type=" text" className="form-control"
                            style={{
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000'
                            }}
                            disabled={(action === 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "SupportWeight", event)}
                            value={model.SupportWeight ? model.SupportWeight : ""}
                        />
                        <button type="button"
                            className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                            onClick={() => this.GuideUser('SupportWeight')}>
                            <i className="fa fa-info-circle" />
                        </button>
                    </div>

                    {/*TIPO DE VENTA*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Tipo de Venta</span>
                                <span className="d-inline d-xl-none">Tipo Venta</span>
                            </span>
                        </div>
                        <Select
                            options={transportType}
                            value={transportType.find(opt => opt.value === model?.U_FMB_SellType) || null}
                            onChange={this.changeTypeSell}
                            placeholder="Selecciona el tipo de venta"
                            isDisabled={action === 2 && !editMode}
                            isSearchable={true}
                            isClearable={true}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1 }),
                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        />
                    </div>

                    {/*TIPO DE UNIDAD*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Tipo de Unidad</span>
                                <span className="d-inline d-xl-none">Tipo Unidad</span>
                            </span>
                        </div>
                        <Select
                            options={tipoUnidad}
                            value={tipoUnidad.find(opt => opt.value === model?.TipodeUnidad) || null}
                            onChange={this.changeTipoUnidad}
                            placeholder="Selecciona el tipo de unidad"
                            isDisabled={action === 2 && !editMode}
                            isSearchable={true}
                            isClearable={true}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1 }),
                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        />
                    </div>

                    {/* GENERAR HOJA DE RUTA */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                Hoja de Ruta Automática
                            </span>
                        </div>

                        <div
                            className="form-control d-flex align-items-center"
                            style={{
                                height: 40,
                                backgroundColor: "transparent",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={model?.roadMap == 'Y'}
                                onChange={this.changeRoadMap}
                                disabled={action === 2 && !editMode}
                                style={{
                                    width: 18,
                                    height: 18,
                                    cursor: action === 2 && !editMode ? "not-allowed" : "pointer",
                                }}
                            />
                        </div>
                    </div>

                </div>
                <br></br>
            </div>
        )
    }

    openItems = async (searchingItem = null) => {
        const { showAlert, model, enableSpinner } = this.props;

        let searchItem = searchingItem !== null ? searchingItem : model.searchItem;

        let getItemResponse = null;
        enableSpinner(true);

        getItemResponse = await apiClient.getItem('', 'transfersRequest', searchItem, model);
        enableSpinner(false);

        if (getItemResponse.data.length === 0) {

            if (!Array.isArray(getItemResponse.data.results)) {
                showAlert({ type: 'info', message: getItemResponse.message });
                return;
            }

            if (getItemResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }

        if (getItemResponse.data.length === 1) {
            this.setState({
                items: getItemResponse.data
            });
            await this.selectItems(getItemResponse.data);
        } else {
            this.setState({
                items: getItemResponse?.data?.results || getItemResponse?.data || [],
                pageTotal: getItemResponse?.data?.totalPage || getItemResponse?.data?.length || 0
            });
            $('#itemsCreate').modal('show');
        }
    };

    changeSearchItem = async (event) => {
        const { model } = this.props;
        if (event.nativeEvent.data !== '') {
            model.searchItem = event.nativeEvent.target.value.trim();
        }
        this.refreshModel(model);
    };

    selectItems = async itemsSelected => {
        const { model, showAlert, enableSpinner } = this.props;

        for (let index = 0; index < itemsSelected.length; index++) {
            const item = itemsSelected[index];

            const alreadyExists = model.Items.some(it => it.ItemCode === item.ItemCode);
            if (alreadyExists) {
                showAlert({ type: 'warning', message: `El artículo ${item.ItemCode} ya existe en la lista.` });
                continue;
            }
            const newItemModel = new ItemsTransporte();
            newItemModel.LineNum = model.Items.length;
            newItemModel.ItemCode = item.ItemCode;
            newItemModel.ItemName = item.ItemName;
            newItemModel.isNew = true;
            newItemModel.Capital = 0;

            model.Items.push(newItemModel);
        }

        model.searchItem = '';
        this.refreshModel(model);

        setTimeout(() => {
            this.setState({
                items: [],
            });
        }, 100);

        $('#itemsCreate').modal('hide');
    };

    changeQuantityItem = async (event, index, specifQty = null) => {
        const { showAlert, model } = this.props;

        let quantity = specifQty !== null ? specifQty : event.nativeEvent.target.value;

        if (quantity.indexOf(" ") !== -1 || quantity.indexOf("-") !== -1) {
            showAlert({ type: 'warning', message: "Carácter no permitido" });
            return;
        }

        if (!isNaN(quantity) && quantity !== '') {
            model.Items[index].Capital = quantity;
        } else if (quantity === '') {
            model.Items[index].Capital = '';
        }

        setTimeout(() => {
            this.refreshModel(model);
        }, 100);

    };

    refreshItems = async (item, totalRows) => {
        this.setState({
            items: item,
            pageTotal: totalRows
        });
    };

    Open_ShowAreYouAgreeModal = async (index, ItemCode) => {
        await this.setState({
            showAreYouAgreeModalDelete: !this.state.showAreYouAgreeModalDelete,
            itemDelete: ItemCode,
            idDelete: index,
        });

        $('#areYouAgreeModal').modal('show');
    };

    Close_AgreeModalDelete = async (status) => {
        await this.setState({ showAreYouAgreeModalDelete: status });
        $('#areYouAgreeModal').modal('hide');
    }

    Delete_Line = async (idDelete) => {
        const { showAlert, enableSpinner, model } = this.props;

        let auxLines = model.Items.slice();
        let id = model.Items[idDelete];
        let data = {
            Id: id.CodigoAutotransporte,
            ItemCode: id.ItemCode
        };
        enableSpinner(true);
        let deleteLine = await apiClient.deleteLineITransporte(data);
        enableSpinner(false);

        if (deleteLine.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: 'success', message: deleteLine?.message });
            auxLines.splice(idDelete, 1); // 1 es la cantidad de elemento a eliminar
            model.Items = auxLines;
            this.refreshModel(model);
        } else {
            showAlert({ type: 'warning', message: deleteLine?.message || '' });
        }
        this.Close_AgreeModalDelete(false)
    };

    renderAutoTransporteBody = () => {
        const { model, action, view, cartaPorteModel, cartaPorteAction, cartaPorteEditMode, SetInitialSeries, documentTypeSeries, OpenSeriesModal } = this.props;
        const { editMode, subTipoRem, configVehicular } = this.state;
        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-transporte-tab-1-2"
                            data-toggle="tab"
                            href="#Section-1-2"
                            role="tab"
                            aria-controls="Section-1-2"
                            aria-selected="true">
                            General
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-transporte-tab-2-2"
                            data-toggle="tab"
                            href="#Section-2-2"
                            role="tab"
                            aria-controls="Section-2-2"
                            aria-selected="false">
                            Seguros
                        </a>
                        {/* <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-transporte-tab-3-2"
                            data-toggle="tab"
                            href="#Section-3-2"
                            role="tab"
                            aria-controls="Section-3-2"
                            aria-selected="false">
                            Remolques
                        </a> */}
                        {/* SERIES Y CORRELATIVOS */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-transporte-tab-consecutives"
                            data-toggle="tab"
                            href="#seriesAndConsecutives"
                            role="tab"
                            aria-controls="seriesAndConsecutives"
                            aria-selected="false"
                            onClick={() => SetInitialSeries()}
                        >
                            Series y Correlativos
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-transporte-tab-items"
                            data-toggle="tab"
                            href="#SectionItems"
                            role="tab"
                            aria-controls="SectionItems"
                            aria-selected="false"
                            onClick={() => SetInitialSeries()}
                        >
                            Capacidad de abastecimiento
                        </a>
                    </div>
                </nav>
                <div className="tab-content" style={{ textAlign: 'left' }}>
                    {/* APARTADO GENERAL */}
                    <div className="container tab-pane active"
                        id="Section-1-2"
                        role="tabpanel"
                        aria-labelledby="nav-transporte-tab-1-2"
                    //  style={{maxHeight: 500}}
                    >
                        <div className="row">
                            {/* Primera columna */}
                            <div className="col-12 col-md-6">
                                {/*PermSCT TRUCK*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">PermSCT</span>
                                            <span className="d-inline d-xl-none">PermSCT</span>
                                        </span>
                                    </div>
                                    <select id="inputState" className="form-control btn-outline-secondary" value={model.PermSCT ? model.PermSCT.trim() : ""}
                                        onChange={(event) => this.changeFieldModel(model, "PermSCT", event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                        <option value=''>Seleccione una opción</option>
                                        <option value='TPAF01'>TPAF01. Autotransporte Federal de carga general.</option>
                                        <option value='TPAF02'>TPAF02. Transporte privado de carga.</option>
                                        <option value='TPAF03'>TPAF03. Autotransporte Federal de Carga Especializada de materiales y residuos peligrosos.</option>
                                        <option value='TPXX00'>TPXX00. Permiso no contemplado en el catálogo.</option>
                                        {/* <option value='TPAF01'>TPAF01. Autotransporte Federal de carga general.</option>
                                        <option value='TPAF02'>TPAF02. Transporte privado de carga.</option>
                                        <option value='TPAF03'>TPAF03. Autotransporte Federal de Carga Especializada de materiales y residuos peligrosos.</option>
                                        <option value='TPAF04'>TPAF04. Transporte de automóviles sin rodar en vehículo tipo góndola.</option>
                                        <option value='TPAF05'>TPAF05. Transporte de carga de gran peso y/o volumen de hasta 90 toneladas.</option>
                                        <option value='TPAF06'>TPAF06. Transporte de carga especializada de gran peso y/o volumen de más 90 toneladas.</option>
                                        <option value='TPAF07'>TPAF07. Transporte Privado de materiales y residuos peligrosos.</option>
                                        <option value='TPAF08'>TPAF08. Autotransporte internacional de carga de largo recorrido.</option>
                                        <option value='TPAF09'>TPAF09. Autotransporte internacional de carga especializada de materiales y residuos peligrosos de largo rec</option>
                                        <option value='TPAF10'>TPAF10. Autotransporte Federal de Carga General cuyo ámbito de aplicación comprende la franja fronteriza con</option>
                                        <option value='TPAF11'>TPAF11. Autotransporte Federal de Carga Especializada cuyo ámbito de aplicación comprende la franja fronteri</option>
                                        <option value='TPAF12'>TPAF12. Servicio auxiliar de arrastre en las vías generales de comunicación.</option>
                                        <option value='TPAF13'>TPAF13. Servicio auxiliar de servicios de arrastre, arrastre y salvamento, y depósito de vehículos en las ví</option>
                                        <option value='TPAF14'>TPAF14. Servicio de paquetería y mensajería en las vías generales de comunicación.</option>
                                        <option value='TPAF15'>TPAF15. Transporte especial para el tránsito de grúas industriales con peso máximo de 90 toneladas.</option>
                                        <option value='TPAF16'>TPAF16. Servicio federal para empresas arrendadoras servicio público federal.</option>
                                        <option value='TPAF17'>TPAF17. Empresas trasladistas de vehículos nuevos.</option>
                                        <option value='TPAF18'>TPAF18. Empresas fabricantes o distribuidoras de vehículos nuevos.</option>
                                        <option value='TPAF19'>TPAF19. Autorización expresa para circular en los caminos y puentes de jurisdicción federal con configuracio</option>
                                        <option value='TPAF20'>TPAF20. Autotransporte Federal de Carga Especializada de fondos y valores.</option>
                                        <option value='TPXX00'>TPXX00. Permiso no contemplado en el catálogo.</option> */}

                                    </select>
                                </div>
                                {/*ConfigVehicular TRUCK*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">ConfigVehicular</span>
                                    </div>
                                    <select id="txtGroupCode" className="form-control btn-outline-secondary" value={model.ConfigVehicular ? model.ConfigVehicular.trim() : ""}
                                        onChange={(event) => this.changeFieldModel(model, "ConfigVehicular", event)}
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                        <option value=''>Seleccione una opción</option>
                                        {!!configVehicular && configVehicular.map((dato => {
                                            return (
                                                <option value={dato.Clave}>{dato.Clave}. {dato.Descripcion}</option>
                                            );
                                        }))}
                                    </select>
                                </div> */}
                            </div>
                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6">
                                {/*NumPermisoSCT TRUCK*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">NumPermisoSCT</span>
                                            <span className="d-inline d-xl-none">Núm Permiso</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NumPermisoSCT", event)}
                                        value={model.NumPermisoSCT ? model.NumPermisoSCT : ""}
                                        id="txtTel2" />
                                </div>


                                {/* PesoBrutoVehicular NUEVO 30 */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">PesoBrutoVehicular</span>
                                            <span className="d-inline d-xl-none">Peso Bruto</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "PesoBrutoVehicular", event)}
                                        value={model.PesoBrutoVehicular ? model.PesoBrutoVehicular : ""}
                                        id="txtTel2" />
                                    <button type="button"
                                        className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        onClick={() => this.GuideUser('PesoBrutoVehicular')}>
                                        <i className="fa fa-info-circle" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* APARTADO SEGUROS */}
                    <div className="container tab-pane fade"
                        id="Section-2-2"
                        role="tabpanel"
                        aria-labelledby="nav-transporte-tab-2-2"
                    //  style={{maxHeight: 500}}
                    >
                        <div className="row">
                            {/* Primera columna */}
                            <div className="col-12 col-md-6">
                                {/*AseguraRespCivil TRUCK*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">AseguraRespCivil</span>
                                            <span className="d-inline d-xl-none">Aseg Resp Civil</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={model.AseguraRespCivil ? model.AseguraRespCivil : ""}
                                        onChange={(event) => this.changeFieldModel(model, "AseguraRespCivil", event)}
                                        id="txtTel2" />
                                </div>
                                {/*AseguraMedAmbiente TRUCK*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">AseguraMedAmbiente</span>
                                            <span className="d-inline d-xl-none">Aseg Med Ambiente</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={model.AseguraMedAmbiente ? model.AseguraMedAmbiente : ""}
                                        onChange={(event) => this.changeFieldModel(model, "AseguraMedAmbiente", event)}
                                        id="txtTel2" />
                                </div>
                                {/*AseguraCarga TRUCK*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">AseguraCarga</span>
                                            <span className="d-inline d-xl-none">Aseg Carga</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={model.AseguraCarga ? model.AseguraCarga : ""}
                                        onChange={(event) => this.changeFieldModel(model, "AseguraCarga", event)}
                                        id="txtTel2" />
                                </div>
                                {/*PrimaSeguro TRUCK*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">PrimaSeguro</span>
                                            <span className="d-inline d-xl-none">Prima Seguro</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        maxLength={10}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        // value={action == 2 ? formatNumber.new(model.PrimaSeguro ? model.PrimaSeguro : 0) : model.PrimaSeguro || 0}
                                        value={model.PrimaSeguro ? model.PrimaSeguro : 0}
                                        onChange={(event) => this.changeFieldModel(model, "PrimaSeguro", event)}
                                        id="txtTel2" />
                                </div>
                            </div>

                            {/*segunda columna*/}
                            <div className="col-12 col-md-6">
                                {/*PolizaRespCivil TRUCK*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">PolizaRespCivil</span>
                                            <span className="d-inline d-xl-none">Poliza Resp Civil</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        maxLength={20}
                                        value={model.PolizaRespCivil ? model.PolizaRespCivil : ""}
                                        onChange={(event) => this.changeFieldModel(model, "PolizaRespCivil", event)}
                                        id="txtTel2" />
                                </div>
                                {/*PolizaMedAmbiente TRUCK*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">PolizaMedAmbiente</span>
                                            <span className="d-inline d-xl-none">Poliza Med Ambiente</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        maxLength={10}
                                        value={model.PolizaMedAmbiente ? model.PolizaMedAmbiente : ""}
                                        onChange={(event) => this.changeFieldModel(model, "PolizaMedAmbiente", event)}
                                        id="txtTel2" />
                                </div>
                                {/*PolizaCarga TRUCK*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">PolizaCarga</span>
                                            <span className="d-inline d-xl-none">Poliza Carga</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control btn-outline-secondary"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        maxLength={10}
                                        value={model.PolizaCarga ? model.PolizaCarga : ""}
                                        onChange={(event) => this.changeFieldModel(model, "PolizaCarga", event)}
                                        id="txtTel2" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* APARTADO Remolques */}
                    {view !== 'consignmentNote' ?
                        <div className="container tab-pane fade"
                            id="Section-3-2"
                            role="tabpanel"
                            aria-labelledby="nav-transporte-tab-3-2"
                        >
                            <div className="row">
                                {/* Primera columna */}
                                <div className="col-12 col-md-6">
                                </div>

                                {/*segunda columna*/}
                                <div className="col-12 col-md-6">
                                    {/*Añadir ParteTransporte*/}
                                    {((action === 1 && editMode !== true) || (action === 2 && editMode)) &&
                                        <div className="input-group mb-3">
                                            <button type="button" className="btn botonCerrar text-white" onClick={() => this.addElement(model, "Remolques", { SubTipoRem: '', Placa: '' })} >{"Añadir Remolque"}</button>
                                        </div>
                                    }
                                </div>
                            </div>
                            {model && model.Remolques !== undefined && model.Remolques.map((element, index) => {
                                return (
                                    <div className="row">
                                        {/* Primera columna */}
                                        <div className="col-12 col-md-6">
                                            {/*SubTipoRem TRUCK*/}
                                            <div className="input-group mb-3">
                                                {/*Eliminar*/}
                                                {((action === 1 && editMode !== true) || (action === 2 && editMode)) &&
                                                    <button type="button" className="btn" onClick={() => this.removeElement(model, "Remolques", index)}
                                                        style={{ backgroundColor: 'transparent', padding: 5, textAlign: "center", color: '#c42222' }}>
                                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                    </button>}
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">SubTipoRem</span>
                                                        <span className="d-inline d-xl-none">Sub. Rem.</span>
                                                    </span>
                                                </div>
                                                <select id={index} className="form-control btn-outline-secondary" value={element.SubTipoRem ? element.SubTipoRem : ""}
                                                    onChange={(event) => this.changeFieldArrayModel(model, "Remolques", "SubTipoRem", index, event)}
                                                    disabled={(action === 2 && !editMode) ? true : false}
                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                                    <option value=''>Seleccione una opción</option>
                                                    {!!subTipoRem && subTipoRem.map((dato => {
                                                        return (
                                                            <option value={dato.Clave}>{dato.Clave}. {dato.Descripcion}</option>
                                                        );
                                                    }))}
                                                </select>
                                            </div>
                                        </div>

                                        {/*segunda columna*/}
                                        <div className="col-12 col-md-6">
                                            {/*Placa TRUCK*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Placa</span>
                                                </div>
                                                <input id={index} type=" text" className="form-control btn-outline-secondary"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000'
                                                    }}
                                                    disabled={(action == 2 && !editMode) ? true : false}
                                                    value={element.Placa ? element.Placa : ""}
                                                    onChange={(event) => this.changeFieldArrayModel(model, "Remolques", "Placa", index, event)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            }
                        </div>
                        :
                        <div className="container tab-pane fade"
                            id="Section-3-2"
                            role="tabpanel"
                            aria-labelledby="nav-transporte-tab-3-2">
                            <div className="row justify-content-around">
                                <div className="col-12">
                                    <div>
                                        <table className="table table-scroll response" style={{ marginBottom: 0 }}>
                                            <div
                                                className="w-100 tab-pane fade show active "
                                                id="dataContenido"
                                                aria-labelledby="nav-home-tab-Contenido"
                                                style={{ maxHeight: 400 }}>
                                                <table
                                                    id="dataTableDocuments"
                                                    className="display"
                                                    style={{ width: '100%', marginBottom: 40, marginRight: -2000 }}>
                                                    <thead className="table-header-yellow">
                                                        <tr style={{ backgroundColor: '#d2ab24', textAlign: "center" }}>
                                                            <td></td>
                                                            <td style={{ textAlign: 'center' }}>Subtipo de remolque</td>
                                                            <td style={{ textAlign: 'center' }}>Placa</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {cartaPorteModel && cartaPorteModel.ConfRemolques !== undefined && cartaPorteModel.ConfRemolques.map((element, index) => {
                                                            const description = subTipoRem?.find(({ Clave }) => element.SubTipoRem === Clave)?.Descripcion;
                                                            return (
                                                                <tr>
                                                                    <td className="sticky-columns" style={{ textAlign: 'center' }}>
                                                                        <input
                                                                            className='form-check-label'
                                                                            type="checkbox"
                                                                            disabled={cartaPorteAction === 2 && !cartaPorteEditMode}
                                                                            checked={element.Active}
                                                                            id={`Remolque-${index}`}
                                                                            onChange={() => this.changeRemolqueStatus(index, !element.Active)}
                                                                        />
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>{element.SubTipoRem ?? ''} - {description ?? ''}</td>
                                                                    <td style={{ textAlign: 'center' }}>{element.Placa ?? ''}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* SERIES Y CORRELATIVOS */}
                    <div className="container tab-pane fade" role="tabpanel" id="seriesAndConsecutives" aria-labelledby="nav-transporte-tab-consecutives">
                        <div className="row">
                            {documentTypeSeries?.map((item, index) => (

                                <div key={index} className="col-12 col-md-6 mb-3">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id={`SERIES-SPAN-${item.Code}`} title={item?.U_BPP_TDDD ?? ''}>{item?.U_BPP_TDDD ?? ''}</span>
                                        </div>
                                        <input type="text" className="form-control input-sm"
                                            id={`SERIES-${item.Code}`}
                                            disabled={true}
                                            value={model?.U_FMB_ValidateSeriesSUNAT?.[item.Code] ?? ''}
                                        />

                                        <button
                                            type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            className="input-group-text"
                                            onClick={() => OpenSeriesModal('SERIES', model?.U_FMB_ValidateSeriesSUNAT?.[item.Code] ?? '', item.Code)}
                                        >
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* ARTICULOS RELACIONADOS */}
                    <div className="container tab-pane fade" role="tabpanel" id="SectionItems" aria-labelledby="nav-transporte-tab-items">
                        <div className="row mb-3">
                            <table className="table table-scroll response" style={{ marginBottom: 0 }}>
                                <div
                                    className="w-100 tab-pane fade show active "
                                    id="dataContenido"
                                    aria-labelledby="nav-home-tab-Contenido"
                                    style={{ maxHeight: 400 }}>
                                    <table
                                        id="dataTableDocuments"
                                        className="display"
                                        style={{ width: '100%', marginBottom: 40, marginRight: -2000 }}>
                                        <thead className="table-header-yellow">
                                            <tr style={{ backgroundColor: '#d2ab24', textAlign: "center" }}>
                                                <td></td>
                                                <td style={{ textAlign: 'center' }}>Artículo</td>
                                                <td style={{ textAlign: 'center' }}>Nombre Artículo</td>
                                                <td style={{ textAlign: 'center' }}>Capital</td>
                                                <td style={{ textAlign: 'center' }}></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!!model.Items && model.Items.map((element, index) => {
                                                // const description = subTipoRem?.find(({ Clave }) => element.SubTipoRem === Clave)?.Descripcion
                                                return (
                                                    <tr>
                                                        <td className="sticky-columns" style={{ textAlign: 'center' }}>
                                                            {index + 1}
                                                        </td>
                                                        <td style={{ textAlign: 'center' }}>{element.ItemCode ?? ''} </td>
                                                        <td style={{ textAlign: 'center' }}>{element.ItemName ?? ''}</td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <input
                                                                type="text"
                                                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                disabled={(action === 2 && !editMode) ? true : false}
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    borderColor: '#ced4da',
                                                                    color: '#000',
                                                                    paddingTop: 1,
                                                                    paddingBottom: 2,
                                                                    maxWidth: 260,
                                                                    minWidth: 120,
                                                                    textAlign: "center",

                                                                }}
                                                                id={'itemCantidad' + index}
                                                                value={element.Capital}
                                                                onChange={event => this.changeQuantityItem(event, index)}
                                                            />
                                                        </td>
                                                        {/* ELIMINAR */}
                                                        <td
                                                            className="sticky-columns"
                                                            style={{
                                                                backgroundColor: '#FFF',
                                                                textAlign: 'center'
                                                            }}>
                                                            {/* disabled={(action == 2 && !editMode) ? true : false} */}
                                                            {((action === 1) || (action === 2 && editMode)) && (
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        padding: 5,
                                                                        color: '#c42222',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                    }}
                                                                    className="btn"
                                                                    onClick={() => this.Open_ShowAreYouAgreeModal(index, element.ItemCode)}>
                                                                    <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );

                                            })}
                                            <tr>
                                                <td></td>
                                                <td className="sticky-column"
                                                    style={{ backgroundColor: '#FFF', textAlign: 'center' }}>

                                                    {((action === 1) || (action === 2 && editMode)) && (
                                                        <div>
                                                            <input
                                                                type=" text"
                                                                placeholder="Artículo"
                                                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                                                // disabled={(action == 2 && !editMode) ? true : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#000',
                                                                    paddingTop: 1,
                                                                    paddingBottom: 2,
                                                                }}
                                                                onKeyPress={(ev) => {
                                                                    if (ev.key === 'Enter') {
                                                                        this.openItems();
                                                                    }
                                                                }}
                                                                value={model.searchItem || ''}
                                                                onChange={event => this.changeSearchItem(event)}
                                                            />
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    padding: 5,
                                                                    color: 'green',
                                                                    paddingTop: 2,
                                                                    paddingBottom: 2,
                                                                }}
                                                                className="btn"
                                                                onClick={() => this.openItems()}>
                                                                <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // Transporte Ferroviario render
    renderRailwayTransportHeader = () => {
        const { model, action, view } = this.props;
        const { editMode } = this.state;

        return (
            <div className="row">
                {/*PRIMER COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*Código*/}
                    {(action != 1 && !editMode) && <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardCode"
                            disabled={(action == 2 || action == 1) && !editMode ? true : false}
                            value={model.CodigoTransporteFerroviario ? model.CodigoTransporteFerroviario : ""}
                        />
                    </div>}
                    {/*TipoDeServicio*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">TipoDeServicio</span>
                        </div>
                        <select id="txtGroupCode" className="form-control "
                            value={model.TipoDeServicio ? model.TipoDeServicio : ""}
                            onChange={(event) => this.changeFieldModel(model, "TipoDeServicio", event)}
                            disabled={(action == 2 && !editMode) ? true : false}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                            <option value=''>Seleccione una opción</option>
                            <option value='TS01'>TS01.Carros Ferroviarios</option>
                            <option value='TS02'>TS02.Carros Ferroviarios intermodal</option>
                            <option value='TS03'>TS03.Tren unitario de carros ferroviarios</option>
                            <option value='TS04'>TS04.Tren unitario intermodal</option>
                        </select>
                    </div>
                    {/*NombreAseg*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">NombreAseg</span>
                        </div>
                        <input type=" text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardName"
                            disabled={(action == 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "NombreAseg", event)}
                            value={model.NombreAseg ? model.NombreAseg : ""}
                        />
                    </div>
                </div>

                {/*SEGUNDA COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*TipoDeTrafico*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">TipoDeTrafico</span>
                        </div>
                        <select id="txtGroupCode" className="form-control "
                            value={model.TipoDeTrafico ? model.TipoDeTrafico : ""}
                            onChange={(event) => this.changeFieldModel(model, "TipoDeTrafico", event)}
                            disabled={(action == 2 && !editMode) ? true : false}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                            <option value=''>Seleccione una opción</option>
                            <option value='TT01'>TT01.Tráfico local </option>
                            <option value='TT02'>TT02.Tráfico interlineal remitido</option>
                            <option value='TT03'>TT03.Tráfico interlineal recibido</option>
                            <option value='TT04'>TT04.Tráfico interlineal en tránsito</option>
                        </select>

                    </div>
                    {/*NumPolizaSeguro*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">NumPolizaSeguro</span>
                        </div>
                        <input type=" text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardName"
                            disabled={(action == 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "NumPolizaSeguro", event)}
                            value={model.NumPolizaSeguro ? model.NumPolizaSeguro : ""}
                        />
                    </div>
                </div>
                <br></br>
            </div>
        )
    }

    renderRailwayTransportBody = () => {
        const { model, action } = this.props;
        const { editMode, subTipoRem, configVehicular } = this.state;
        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-transporte-tab-1-3"
                            data-toggle="tab"
                            href="#Section-1-3"
                            role="tab"
                            aria-controls="Section-1-3"
                            aria-selected="true">
                            DerechosDePaso
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-transporte-tab-2-3"
                            data-toggle="tab"
                            href="#Section-2-3"
                            role="tab"
                            aria-controls="Section-2-3"
                            aria-selected="false">
                            Carro
                        </a>
                    </div>
                </nav>
                <div className="tab-content" style={{ textAlign: 'left' }}>


                    {/* APARTADO DerechosDePaso */}
                    <div className="container tab-pane active"
                        id="Section-1-3"
                        role="tab"
                        aria-labelledby="nav-transporte-tab-1-3"
                    //  style={{maxHeight: 500}}
                    >

                        <div className="row">
                            {/* Primera columna */}
                            <div className="col-12 col-md-6">
                            </div>
                            {/*segunda columna*/}
                            <div className="col-12 col-md-6"><br></br>
                                {/*Añadir DerechoPaso*/}
                                {((action === 1 && editMode !== true) || (action === 2 && editMode)) &&
                                    <div className="input-group mb-3">
                                        <button type="button" className="btn botonCerrar text-white" onClick={() => this.addElement(model, "DerechosDePaso", { TipoDerechoDePaso: '', KilometrajePagado: '' })} >{"Añadir"}</button>
                                    </div>
                                }
                            </div>
                        </div>

                        {model && model.DerechosDePaso !== undefined && model.DerechosDePaso.map((element, index) => {
                            return (
                                <div className="row">
                                    {/*Primera columna*/}
                                    <div className="col-12 col-md-6">
                                        {/*TipoDerechoDePaso*/}
                                        <div className="input-group mb-3">

                                            {/*Eliminar*/}
                                            {((action === 1 && editMode !== true) || (action === 2 && editMode)) &&
                                                <button type="button" className="btn" onClick={() => this.removeElement(model, "DerechosDePaso", index)}
                                                    style={{ backgroundColor: 'transparent', padding: 5, textAlign: "center", color: '#c42222' }}>
                                                    <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                </button>}

                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">TipoDerechoDePaso</span>
                                            </div>
                                            <select id="txtGroupCode" className="form-control btn-outline-secondary"
                                                value={element.TipoDerechoDePaso ? element.TipoDerechoDePaso : ""}
                                                onChange={(event) => this.changeFieldArrayModel(model, "DerechosDePaso", "TipoDerechoDePaso", index, event)}
                                                disabled={(action == 2 && !editMode) ? true : false}
                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                                <option value=''>Seleccione una opción</option>

                                                <option value='CDP001'>CDP001. D-1, Torreón (Km. DA-251+000) - Villa Juárez (Km. DA-238+000), Recibe</option>
                                                <option value='CDP002'>CDP002. D-1, Torreón (Km. DA-251+000) - Villa Juárez (Km. DA-238+000), Otorga</option>
                                                <option value='CDP003'>CDP003. DPL-1, Mariscala (Km. A-263+922) - Guadalajara (Km. I-259+500), Otorga</option>
                                                <option value='CDP004'>CDP004. DPL-1, Mariscala (Km. A-263+922) - Guadalajara (Km. I-259+500), Recibe</option>
                                                <option value='CDP005'>CDP005. DPL-2, Viborillas (Km. BC-8+756) - Encantada (Km.B-892+875), Recibe</option>
                                                <option value='CDP006'>CDP006. DPL-2, Viborillas (Km. BC-8+756) - Encantada (Km. B-892+875), Otorga</option>

                                                {/* {!!TipoDerechoDePaso && TipoDerechoDePaso.map( (dato => {
                                                    return(
                                                        <option value={dato.Clave}>{dato.Clave}. {dato.Descripcion}</option>
                                                    );
                                                }))} */}
                                            </select>
                                        </div>

                                    </div>

                                    {/*Segunda columna*/}
                                    <div className="col-12 col-md-6">
                                        {/*KilometrajePagado */}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">KilometrajePagado</span>
                                            </div>
                                            <input type="text" className="form-control"
                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                id="txtTel1"
                                                disabled={(action == 2 && !editMode) ? true : false}
                                                onChange={(event) => this.changeFieldArrayModel(model, "DerechosDePaso", "KilometrajePagado", index, event)}
                                                value={element.KilometrajePagado ? element.KilometrajePagado : ""}
                                            />
                                        </div>
                                    </div>

                                </div>
                            )
                        })
                        }

                    </div>

                    {/* APARTADO Carro */}
                    <div className="container tab-pane fade"
                        id="Section-2-3"
                        role="tab"
                        aria-labelledby="nav-transporte-tab-2-3"
                    //  style={{maxHeight: 500}}
                    >

                        <div style={{ marginTop: 30 }}>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary active"
                                        id="nav-transporte-tab-11"
                                        data-toggle="tab"
                                        href="#Section-11"
                                        role="tab"
                                        aria-controls="Section-11"
                                        aria-selected="true">
                                        Datos Generales
                                    </a>
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary  "
                                        id="nav-transporte-tab-12"
                                        data-toggle="tab"
                                        href="#Section-12"
                                        role="tab"
                                        aria-controls="Section-12"
                                        aria-selected="false">
                                        Contenedor
                                    </a>
                                </div>
                            </nav>
                            {/* {model && model.Carro !== undefined && model.Carro.map( (element, index) => {
                                return( */}
                            <div className="tab-content" style={{ textAlign: 'left' }}>
                                {/* Datos generales Carro */}
                                <div className="container tab-pane active"
                                    id="Section-11"
                                    role="tab"
                                    aria-labelledby="nav-transporte-tab-11"
                                //  style={{maxHeight: 500}}
                                >
                                    <div className="row col-sm col" style={{ paddingRight: 0 }}>
                                        {/*Primera columna*/}
                                        <div className="col-12 col-md-6"><br></br>
                                            {/*TipoCarro*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">TipoCarro</span>
                                                </div>
                                                <select id="txtGroupCode" className="form-control"
                                                    value={model.Carro && model.Carro[0].TipoCarro ? model.Carro[0].TipoCarro : ""}
                                                    onChange={(event) => this.changeFieldArrayModel(model, "Carro", "TipoCarro", 0, event)}
                                                    disabled={(action == 2 && !editMode) ? true : false}
                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                                    <option value=''>Seleccione una opción</option>
                                                    <option value='TC01'>TC01.Furgón</option>
                                                    <option value='TC02'>TC02.Góndola</option>
                                                    <option value='TC03'>TC03.Tolva</option>
                                                    <option value='TC04'>TC04.Tanque</option>
                                                    <option value='TC05'>TC05.Plataforma Intermodal</option>
                                                    <option value='TC06'>TC06.Plataforma de Uso General</option>
                                                    <option value='TC07'>TC07.Plataforma Automotriz</option>
                                                    <option value='TC08'>TC08.Locomotora</option>
                                                    <option value='TC09'>TC09.Carro Especial</option>
                                                    <option value='TC10'>TC10.Pasajeros</option>
                                                    <option value='TC11'>TC11.Mantenimiento de Vía</option>
                                                </select>


                                            </div>

                                            {/*PesoNetoTotal */}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">ToneladasNetasCarro</span>
                                                </div>
                                                <input type="text" className="form-control"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000'
                                                    }}
                                                    id="txtTel1"
                                                    disabled={(action == 2 && !editMode) ? true : false}
                                                    onChange={(event) => this.changeFieldArrayModel(model, "Carro", "ToneladasNetasCarro", 0, event)}
                                                    value={model.Carro && model.Carro[0].ToneladasNetasCarro ? model.Carro[0].ToneladasNetasCarro : ""}
                                                />
                                            </div>
                                        </div>

                                        {/*Segunda columna*/}
                                        <div className="col-sm" style={{ paddingRight: 0 }}><br></br>
                                            {/*MatriculaCarro*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">MatriculaCarro</span>
                                                </div>
                                                <input type=" text" className="form-control"
                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                    disabled={(action == 2 && !editMode) ? true : false}
                                                    onChange={(event) => this.changeFieldArrayModel(model, "Carro", "MatriculaCarro", 0, event)}
                                                    value={model.Carro && model.Carro[0].MatriculaCarro ? model.Carro[0].MatriculaCarro : ""}
                                                    id="txtTel2" />
                                            </div>

                                            {/*GuiaCarro*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">GuiaCarro</span>
                                                </div>
                                                <input type="text" className="form-control"
                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                    id="txtTel1"
                                                    disabled={(action == 2 && !editMode) ? true : false}
                                                    onChange={(event) => this.changeFieldArrayModel(model, "Carro", "GuiaCarro", 0, event)}
                                                    value={model.Carro && model.Carro[0].GuiaCarro ? model.Carro[0].GuiaCarro : ""}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Contenedor Carro */}
                                <div className="w-100 table-scroll tab-pane fade"
                                    id="Section-12"
                                    role="tab"
                                    aria-labelledby="nav-transporte-tab-12"
                                    style={{/*maxHeight: 500*/ paddingTop: 5 }}
                                >

                                    <div className="row col-sm col" style={{ paddingRight: 0 }}>
                                        {/*Primera columna*/}
                                        <div className="col-12 col-md-6"><br></br>
                                            {/*TipoContenedor*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">TipoContenedor</span>
                                                </div>


                                                <select id="txtGroupCode" className="form-control "
                                                    value={model.Contenedor && model.Contenedor[0].TipoContenedor ? model.Contenedor[0].TipoContenedor : ""}
                                                    onChange={(event) => this.changeFieldArrayModel(model, "Contenedor", "TipoContenedor", 0, event)}
                                                    disabled={(action == 2 && !editMode) ? true : false}
                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                                    <option value=''>Seleccione una opción</option>
                                                    <option value='TC01'>TC01.Contenedor de 6.1 Mts de longitud </option>
                                                    <option value='TC02'>TC02.Contenedor de 12.2 Mts de longitud</option>
                                                    <option value='TC03'>TC03.Contenedor de 13.7 Mts de longitud</option>
                                                    <option value='TC04'>TC04.Contenedor de 14.6 Mts de longitud</option>
                                                    <option value='TC05'>TC05.Contenedor de 16.1 Mts de longitud</option>
                                                </select>
                                            </div>

                                            {/*PesoContenedorVacio*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">PesoContenedorVacio</span>
                                                </div>
                                                <input type="text" className="form-control"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000'
                                                    }}
                                                    id="txtTel1"
                                                    disabled={(action == 2 && !editMode) ? true : false}
                                                    onChange={(event) => this.changeFieldArrayModel(model, "Contenedor", "PesoContenedorVacio", 0, event)}
                                                    value={model.Contenedor && model.Contenedor[0].PesoContenedorVacio ? model.Contenedor[0].PesoContenedorVacio : ""}
                                                />
                                            </div>
                                        </div>

                                        {/*Segunda columna*/}
                                        <div className="col-sm" style={{ paddingRight: 0 }}><br></br>
                                            {/*PesoNetoMercancia*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">PesoNetoMercancia</span>
                                                </div>
                                                <input type=" text" className="form-control"
                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                    disabled={(action == 2 && !editMode) ? true : false}
                                                    onChange={(event) => this.changeFieldArrayModel(model, "Contenedor", "PesoNetoMercancia", 0, event)}
                                                    value={model.Contenedor && model.Contenedor[0].PesoNetoMercancia ? model.Contenedor[0].PesoNetoMercancia : ""}
                                                    id="txtTel2" />
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                            {/* )
                            })} */}
                        </div>

                    </div>


                </div>
            </div>
        )
    }

    // Transporte Maritimo render
    renderMarineTransportHeader = () => {
        const { model, action, view } = this.props;
        const { editMode } = this.state;

        return (
            <div className="row">
                {/*PRIMER COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*Código*/}
                    {(action != 1 && !editMode) && <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardCode"
                            disabled={(action == 2 || action == 1) && !editMode ? true : false}
                            value={model.CodigoTransporteMaritimo ? model.CodigoTransporteMaritimo : ""}
                        />
                    </div>}
                    {/*PermSCT*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">PermSCT</span>
                        </div>
                        <select id="txtGroupCode" className="form-control "
                            value={model.PermSCT ? model.PermSCT : ""}
                            onChange={(event) => this.changeFieldModel(model, "PermSCT", event)}
                            disabled={(action == 2 && !editMode) ? true : false}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                            <option value=''>Seleccione una opción</option>
                            <option value='TPTM01'>TPTM01. Permiso temporal para navegación de cabotaje</option>
                        </select>
                    </div>

                    {/*TipoEmbarcacion */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">TipoEmbarcacion</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtTel1"
                            disabled={(action == 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "TipoEmbarcacion", event)}
                            value={model.TipoEmbarcacion ? model.TipoEmbarcacion : ""}
                        />
                    </div>

                </div>

                {/*SEGUNDA COLUMNA*/}
                <div className="col-12 col-md-6">

                    {/*NumPermisoSCT*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">NumPermisoSCT</span>
                        </div>
                        <input type=" text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardName"
                            disabled={(action == 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "NumPermisoSCT", event)}
                            value={model.NumPermisoSCT ? model.NumPermisoSCT : ""}
                        />
                    </div>

                    {/*Matricula */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Matricula</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtTel1"
                            disabled={(action == 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "Matricula", event)}
                            value={model.Matricula ? model.Matricula : ""}
                        />
                    </div>

                </div>
                <br></br>
            </div>
        )
    }

    renderMarineTransportBody = () => {
        const { model, action, countries } = this.props;
        const { editMode } = this.state;
        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-transporte-tab-1-4"
                            data-toggle="tab"
                            href="#Section-1-4"
                            role="tab"
                            aria-controls="Section-1-4"
                            aria-selected="true">
                            Seguro y Embarcación
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-transporte-tab-2-4"
                            data-toggle="tab"
                            href="#Section-2-4"
                            role="tab"
                            aria-controls="Section-2-4"
                            aria-selected="false">
                            Información Embarque
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-transporte-tab-3-4"
                            data-toggle="tab"
                            href="#Section-3-4"
                            role="tab"
                            aria-controls="Section-3-4"
                            aria-selected="false">
                            Linea Naviera
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-transporte-tab-4-4"
                            data-toggle="tab"
                            href="#Section-4-4"
                            role="tab"
                            aria-controls="Section-4-4"
                            aria-selected="false">
                            Contenedor
                        </a>
                    </div>
                </nav>
                <div className="tab-content" style={{ textAlign: 'left' }}>

                    {/* APARTADO SeguroEmbarcacion */}
                    <div className="container tab-pane active"
                        id="Section-1-4"
                        role="tab"
                        aria-labelledby="nav-transporte-tab-1-4"
                    //  style={{maxHeight: 500}}
                    >

                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            {/*Primera columna*/}
                            <div className="col-12 col-md-6"><br></br>
                                {/*NombreAseg */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NombreAseg</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NombreAseg", event)}
                                        value={model.NombreAseg ? model.NombreAseg : ""}
                                    />
                                </div>

                                {/*NumeroOMI */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumeroOMI</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NumeroOMI", event)}
                                        value={model.NumeroOMI ? model.NumeroOMI : ""}
                                    />
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>
                                {/*NumPolizaSeguro */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumPolizaSeguro</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NumPolizaSeguro", event)}
                                        value={model.NumPolizaSeguro ? model.NumPolizaSeguro : ""}
                                    />
                                </div>

                                {/*NumCertITC */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumCertITC</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NumCertITC", event)}
                                        value={model.NumCertITC ? model.NumCertITC : ""}
                                    />
                                </div>

                            </div>

                        </div>

                    </div>

                    {/* APARTADO InformacionEmbarque */}
                    <div className="container tab-pane fade"
                        id="Section-2-4"
                        role="tab"
                        aria-labelledby="nav-transporte-tab-2-4"
                    //  style={{maxHeight: 500}}
                    >

                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            {/*Primera columna*/}
                            <div className="col-12 col-md-6"><br></br>
                                {/*NombreEmbarc */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NombreEmbarc</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NombreEmbarc", event)}
                                        value={model.NombreEmbarc ? model.NombreEmbarc : ""}
                                    />
                                </div>

                                {/*NacionalidadEmbarc */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NacionalidadEmbarc</span>
                                    </div>
                                    <select id="txtGroupCode" className="form-control btn-outline-secondary" value={model.NacionalidadEmbarc ? model.NacionalidadEmbarc.trim() : ""}
                                        onChange={(event) => this.changeFieldModel(model, "NacionalidadEmbarc", event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                        <option value=''>Seleccione una opción</option>
                                        {!!countries && countries.map((dato => {
                                            return (
                                                <option value={dato.c_Pais}>{dato.Nombre}</option>
                                            );
                                        }))}
                                    </select>
                                    {/* <input type="text" className="form-control"
                                            style={{backgroundColor: 'transparent',borderColor: '#ced4da',color: '#000'}}
                                            id="txtTel1"
                                            disabled={(action == 2 && !editMode) ? true : false}
                                            onChange={(event) => this.changeFieldModel(model, "NacionalidadEmbarc", event)}
                                            value={model.NacionalidadEmbarc ? model.NacionalidadEmbarc : ""}
                                        /> */}
                                </div>

                                {/*UnidadesDeArqBruto */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">UnidadesDeArqBruto</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "UnidadesDeArqBruto", event)}
                                        value={model.UnidadesDeArqBruto ? model.UnidadesDeArqBruto : ""}
                                    />
                                </div>

                                {/*Calado */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Calado</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "Calado", event)}
                                        value={model.Calado ? model.Calado : ""}
                                    />
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>
                                {/*TipoCarga */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">TipoCarga</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "TipoCarga", event)}
                                        value={model.TipoCarga ? model.TipoCarga : ""}
                                    />
                                </div>

                                {/*AnioEmbarcacion */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">AnioEmbarcacion</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "AnioEmbarcacion", event)}
                                        value={model.AnioEmbarcacion ? model.AnioEmbarcacion : ""}
                                    />
                                </div>

                                {/*Eslora */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Eslora</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "Eslora", event)}
                                        value={model.Eslora ? model.Eslora : ""}
                                    />
                                </div>

                                {/*Manga */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Manga</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "Manga", event)}
                                        value={model.Manga ? model.Manga : ""}
                                    />
                                </div>

                            </div>

                        </div>
                    </div>


                    {/* APARTADO LineaNaviera */}
                    <div className="container tab-pane fade"
                        id="Section-3-4"
                        role="tab"
                        aria-labelledby="nav-transporte-tab-3-4"
                    //  style={{maxHeight: 500}}
                    >

                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            {/*Primera columna*/}
                            <div className="col-12 col-md-6"><br></br>
                                {/*LineaNaviera */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">LineaNaviera</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "LineaNaviera", event)}
                                        value={model.LineaNaviera ? model.LineaNaviera : ""}
                                    />
                                </div>

                                {/*NumAutorizacionNaviero */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumAutorizacionNaviero</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NumAutorizacionNaviero", event)}
                                        value={model.NumAutorizacionNaviero ? model.NumAutorizacionNaviero : ""}
                                    />
                                </div>

                                {/*NumConocEmbarc */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumConocEmbarc</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NumConocEmbarc", event)}
                                        value={model.NumConocEmbarc ? model.NumConocEmbarc : ""}
                                    />
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>
                                {/*NombreAgenteNaviero */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NombreAgenteNaviero</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NombreAgenteNaviero", event)}
                                        value={model.NombreAgenteNaviero ? model.NombreAgenteNaviero : ""}
                                    />
                                </div>

                                {/*NumViaje */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumViaje</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NumViaje", event)}
                                        value={model.NumViaje ? model.NumViaje : ""}
                                    />
                                </div>

                            </div>

                        </div>
                    </div>

                    {/* APARTADO Contenedor */}
                    <div className="container tab-pane fade"
                        id="Section-4-4"
                        role="tab"
                        aria-labelledby="nav-transporte-tab-4-4"
                    //  style={{maxHeight: 500}}
                    >

                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            {/*Primera columna*/}
                            <div className="col-12 col-md-6"><br></br>
                                {/*MatriculaContenedor */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">MatriculaContenedor</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={model.Contenedor && model.Contenedor[0].MatriculaContenedor ? model.Contenedor[0].MatriculaContenedor : ""}
                                        onChange={(event) => this.changeFieldArrayModel(model, "Contenedor", "MatriculaContenedor", 0, event)}
                                    />
                                </div>

                                {/*NumPrecinto */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumPrecinto</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={model.Contenedor && model.Contenedor[0].NumPrecinto ? model.Contenedor[0].NumPrecinto : ""}
                                        onChange={(event) => this.changeFieldArrayModel(model, "Contenedor", "NumPrecinto", 0, event)}
                                    />
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>
                                {/*TipoContenedor */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">TipoContenedor</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={model.Contenedor && model.Contenedor[0].TipoContenedor ? model.Contenedor[0].TipoContenedor : ""}
                                        onChange={(event) => this.changeFieldArrayModel(model, "Contenedor", "TipoContenedor", 0, event)}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    //#endregion

    renderBody = () => {
        const { tipoTransporte } = this.props;
        switch (tipoTransporte) {
            case 'Aereo':
                return <div> {this.renderAirTransportHeader()} {this.renderAirTransportBody()} </div>
            case 'Autotransporte':
                return <div> {this.renderAutoTransporteHeader()} {this.renderAutoTransporteBody()} </div>
            case 'Ferroviario':
                return <div> {this.renderRailwayTransportHeader()} {this.renderRailwayTransportBody()} </div>
            case 'Maritimo':
                return <div> {this.renderMarineTransportHeader()} {this.renderMarineTransportBody()} </div>
            default: return <div></div>
        }
    }

    renderEditButton = () => {
        const { action, view } = this.props;
        const { editMode } = this.state;
        if (action === 2 && !editMode && view !== 'consignmentNote') {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: 'transparent', color: '#000' }}
                    className="btn btn-editar"
                    onClick={this.editMode}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }
    };

    CloseDocumentModal = async () => {
        await this.setState({
            showDocumentModal: false
        });

    }
    generateRoadMap = async () => {
        const { enableSpinner, model, showAlert } = this.props;
        const data = {
            transporte: model.CodigoAutotransporte
        }
        enableSpinner(true);
        let responseRoadMap = await apiClient.generateRoadMapT(data);
        enableSpinner(false);
        if (responseRoadMap.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: 'info', message: responseRoadMap?.message ?? '-', timeOut: 10000 });
        } else {
            showAlert({ type: 'error', message: responseRoadMap?.message ?? 'Error de conexión', timeOut: 10000 });
        }
    }

    render() {
        const { action, tipoTransporte, acceptDeleteModel, showSeriesModal, model, checkbox, SaveSeries, CloseSeriesModal } = this.props;
        const { editMode, showAreYouAgreeModal, showBinLocationsModal, listBinLocations,
            items,
            pageTotal,
            showAreYouAgreeModalDelete,
            itemDelete,
            idDelete,
        } = this.state;
        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="Transporte"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true">
                {showBinLocationsModal && <StandardSelectModal
                    id="sucursalLocationsModal"
                    title={"UBICACIONES DE SUCURSAL"}
                    headers={[
                        { title: "Ubicación", value: true, filter: true, field: "BinCode" },
                    ]}
                    data={listBinLocations ?? []}
                    selectAction={this.selectBinLocation}
                    selectedItems={[]}
                    disabled={false}
                    idSelection="BinCode"
                    validNoSelection={true} />}
                {showSeriesModal &&
                    <SeriesModal
                        action={action}
                        adminUsersModel={model}
                        checkbox={checkbox}
                        editMode={editMode}
                        SaveSeries={SaveSeries}
                        CloseSeriesModal={CloseSeriesModal}
                    />
                }
                <ConfirmModalCartaPorte
                    CloseDocumentModal={this.CloseDocumentModal} />


                <ItemsCreateModal
                    data={items}
                    totalPage={pageTotal}
                    newOrderModel={model}
                    mainView={'transfersRequest'}
                    selectItems={this.selectItems}
                    cleanData={() => this.setState({ items: [] })}
                    refreshItems={this.refreshItems}
                />
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">DATOS DEL {this.changeTitleTransporte()}</h4>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        {/* Tipo de transporte */}
                                        {action === 1 &&
                                            <div className="input-group mb-3" >
                                                {/* <label style={{ marginRight: '1.5rem' }}>
                                                    <input type="radio" checked={(tipoTransporte === 'Aereo') ? true : false} onChange={() => this.changeTipoTransporte('Aereo')} />
                                                    <span style={{ padding: '0.5rem' }}>Transporte Aéreo</span>
                                                </label> */}
                                                <label style={{ marginRight: '1.5rem' }}>
                                                    <input type="radio" checked={(tipoTransporte === 'Autotransporte') ? true : false} onChange={() => this.changeTipoTransporte('Autotransporte')} />
                                                    <span style={{ padding: '0.5rem' }}>Autotransporte</span>
                                                </label>
                                                {/* <label style={{ marginRight: '1.5rem' }}>
                                                    <input type="radio" checked={(tipoTransporte === 'Ferroviario') ? true : false} onChange={() => this.changeTipoTransporte('Ferroviario')} />
                                                    <span style={{ padding: '0.5rem' }}>Transporte Ferroviario</span>
                                                </label> */}
                                                {/* <label style={{ marginRight: '1.5rem' }}>
                                                    <input type="radio" checked={(tipoTransporte === 'Maritimo') ? true : false} onChange={() => this.changeTipoTransporte('Maritimo')} />
                                                    <span style={{ padding: '0.5rem' }}>Transporte Marítimo</span>
                                                </label> */}
                                                <br />
                                            </div>
                                        }
                                        <br />
                                        <div>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                {this.renderEditButton()}
                                                {this.renderBody()}
                                                <br></br><br></br>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {/* {action !== 1 && !editMode && view !== 'consignmentNote' && (
                                <button type="button" className="btn botonCerrar text-white" style={{ background: '#c42222 !important' }} onClick={this.deleteModel}>
                                    Eliminar
                                </button>
                            )} */}
                            {action === 2 && !editMode && (
                                <>
                                    <i
                                        className="fa-solid fa-circle-info"
                                        style={{
                                            color: "#EABF28",
                                            cursor: "pointer",
                                            fontSize: 20
                                        }}
                                        onClick={this.togglePopup}
                                    ></i>
                                    <button type="button" className="btn thirdBtn" onClick={this.generateRoadMap}>
                                        Generar Hoja de ruta
                                    </button>
                                </>
                            )}
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar</button>
                            {action === 1 && <button type="button" className="btn botonCorrect text-black"
                                onClick={this.sendModel}> Crear</button>}
                            {action === 2 && editMode && (
                                <button type="button" className="btn btn-danger text-white" onClick={() => this.openCloseAgreeModal(true)}>
                                    Eliminar
                                </button>
                            )}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                    Guardar
                                </button>
                            )}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {showAreYouAgreeModal && <AreYouAgreeModal
                    mensaje={'¿Seguro que deseas eliminar este ' + this.changeTitleTransporte().toLowerCase() + '?'}
                    accept={acceptDeleteModel}
                    cancel={() => this.openCloseAgreeModal(false)}
                />}


                {showAreYouAgreeModalDelete && <AreYouAgreeModal
                    mensaje={'¿Seguro que deseas eliminar este artículo: ' + itemDelete + '?'}
                    accept={() => this.Delete_Line(idDelete)}
                    cancel={() => this.Close_AgreeModalDelete(false)}
                />}
            </div>
        );
    }

    GuideUser = (buttonIdentifier) => {
        const { showAlert } = this.props;

        switch (buttonIdentifier) {
            case 'PesoBrutoVehicular':
                showAlert({ type: 'info', message: 'Este campo debe de ser el peso Bruto del vehículo en donde se trasporta con maximo de 2 decimales. Podrias guardarlo con mas, pero se redondeara a 2 al final de timbre', timeOut: 10000 });
                break;
            case 'SupportWeight':
                showAlert({ type: 'info', message: 'TONELADAS - Este campo debe de ser el peso maximo de carga que soporta el vehiculo en toneladas segun su ficha tecnica', timeOut: 10000 });
                break;

            default:
                break;
        }

    }
}
export default TransporteModal;


